import type { RichText } from '@diana/contracts';

import { CompactRichTextField } from '../../components/CompactRichTextField.js';

type RichTextEditorProps = {
  label: string;
  value: RichText;
  onChange(value: RichText): void;
};

export function RichTextEditor({ label, value, onChange }: RichTextEditorProps) {
  return (
    <CompactRichTextField label={label} value={value} variant="extended" onChange={onChange} />
  );
}
